<template>
  <v-container>
    <v-row>
      <v-col cols="auto" md="auto">
        <v-btn @click="openFormDialog" class="accent shadow-4 px-8" color="success" large rounded>
          Consultar
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn color="info" @click="exportPricing" small rounded fab>
          <v-icon> mdi-download </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- show-expand
        single-expand -->
    <br />

    <v-data-table
      :search="search"
      :headers="headers"
      :items="pricingsList"
      item-key="tarificador.id"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, 100],
      }"
    >
      <template v-slot:expanded-item="{ item }">
        <td :colspan="10">
          <v-container>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Extensión
                    </th>
                    <th class="text-left">
                      Cantidad de llamadas
                    </th>
                    <th class="text-left">
                      T. Duración
                    </th>
                    <th class="text-left">
                      T. Hablado
                    </th>
                    <th class="text-left">
                      Valor
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(i, key) in item.resumen" :key="key">
                    <td>{{ i.ext }}</td>
                    <td>{{ decimalFormatter(i.TCalls) || "0" }}</td>
                    <td>{{ decimalFormatter(i.mnDuracion) || "0" }}</td>
                    <td>{{ decimalFormatter(i.mnHablado) || "0" }}</td>
                    <td>{{ currencyFormatter(i.mnValor) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- <v-row>
              <v-col cols="12" md="2" v-if="item.resumen.ext != undefined">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.resumen.ext
                    }}</v-list-item-title>
                    <v-list-item-subtitle>Extensión</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12" md="2">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      decimalFormatter(item.resumen.TCalls)
                    }}</v-list-item-title>
                    <v-list-item-subtitle
                      >Tiempo de llamada</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12" md="2">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      decimalFormatter(item.resumen.mnDuracion)
                    }}</v-list-item-title>
                    <v-list-item-subtitle>M. hablado</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12" md="2">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      decimalFormatter(item.resumen.mnHablado)
                    }}</v-list-item-title>
                    <v-list-item-subtitle> M. Duración</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12" md="2">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      currencyFormatter(item.resumen.mnValor)
                    }}</v-list-item-title>
                    <v-list-item-subtitle>M. Valor</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row> -->
          </v-container>
        </td>
      </template>
      <!-- <template v-slot:[`item.action`]="{ item }">
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'accent' : 'blue-grey'"
            @click.stop="handleEdit(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-hover>

        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'error' : 'blue-grey'"
            @click.stop="handleDelete(item)"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-hover>
      </template> -->
    </v-data-table>

    <newForm
      v-if="isOpenForm"
      :isActive="isOpenForm"
      @close:dialog="closeFormDialog"
      @dialog:submit="getPrincings"
    ></newForm>
  </v-container>
</template>

<script>
import moment from "moment";
import { PbxHttpClient } from "@/services/httpclient";
import newForm from "./newForm.vue";

export default {
  name: "PricingCdrReport",

  components: {
    newForm,
    // btnupdate,
  },

  data: () => ({
    isLoading: false,
    isOpenForm: true,
    expanded: [],
    // For pagination
    totalItems: 0,
    options: { page: 1, itemsPerPage: 15 },
    // End for pagination
    pricingsList: [],
    search: "",
    headers: [
      {
        text: "Tipo",
        align: "left",
        value: "type",
        class: "primary--text",
        width: "20%",
      },
      {
        text: "Fecha Inicial",
        align: "left",
        value: "dateStart",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Fecha Final",
        value: "dateEnd",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Largo origen",
        value: "totalBillSec",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Contexto",
        value: "context",
        class: "primary--text",
        width: "20%",
      },
      {
        text: "Troncal",
        value: "troncal",
        class: "primary--text",
        width: "20%",
      },
      // {
      //   text: "Acciones",
      //   value: "action",
      //   class: "primary--text",
      //   width: "15%",
      //   align: "left",
      //   sortable: false,
      // },
    ],
    payload: {
      dateStart: new Date().toISOString().substr(0, 10),
      dateEnd: new Date().toISOString().substr(0, 10),
      tarificador_id: null,
    },
  }),

  // watch: {
  //   options: {
  //     handler() {
  //       this.getPrincings();
  //     },
  //     deep: true,
  //   },
  // },

  methods: {
    currencyFormatter(value) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        minimumFractionDigits: 2,
        currency: "USD",
        // currencyDisplay: "symbol",
      });
      return formatter.format(value);
    },

    decimalFormatter(value) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 0,
        // currencyDisplay: "symbol",
      });
      return formatter.format(value);
    },

    openFormDialog() {
      this.isOpenForm = true;
    },

    closeFormDialog() {
      this.isOpenForm = false;
    },

    async getPrincings(payload = this.payload) {
      this.isOpenForm = false;
      this.isLoading = true;
      this.payload = payload;

      const { data } = await PbxHttpClient.post(`/report-tarificador-marcador`, payload);
      const rows = [];

      for (const result of data.results) {
        const obj = {
          type: result.type,
          dateStart: data.dateStart,
          dateEnd: data.dateEnd,
          totalBillSec: result.total_billsec,
        };
        rows.push(obj);
      }

      this.pricingsList = rows;

      this.isLoading = false;
    },
    async exportPricing() {
      try {
        const { data } = await PbxHttpClient.post(
          `/export-tarificador-cdr`,
          {
            start_date: this.payload.dateStart,
            end_date: this.payload.dateEnd,
          },
          { responseType: "blob" },
        );
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Reporte Tarifador de ${moment(this.payload.dateStart).format("YYYY-MM-DD")}-${moment(
            this.payload.dateEnd,
          ).format("YYYY-MM-DD")}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.log("error", error);
      }
    },
  },
};
</script>

<style></style>
